import { type FragmentOf, graphql, readFragment, type Scalar } from "@/graphql"
import { isAgreementCancelled } from "./isAgreementCancelled"

const graphQLFragments = {
    agreement: graphql(
        `
            fragment isAgreementSigned_Agreement on AgreementType {
                __typename
                status
                ...isAgreementCancelled_Agreement
            }
        `,
        [isAgreementCancelled.fragments.agreement]
    ),
}

const AGREEMENT_IN_ACTIVATION_PROCESS_STATUS = [
    "APPLICATION_REJECTED",
    "AWAITING_CHECKOUT",
    "AWAITING_PAYMENT_DETAILS",
] as const satisfies Array<Scalar<"ActivationProcessStatus">>

export function isAgreementSigned(fragment: FragmentOf<typeof graphQLFragments.agreement>) {
    const agreement = readFragment(graphQLFragments.agreement, fragment)

    if (!agreement.status) {
        return false
    }

    return (
        !AGREEMENT_IN_ACTIVATION_PROCESS_STATUS.includes(agreement.status) &&
        !isAgreementCancelled({ agreement })
    )
}

isAgreementSigned.fragments = graphQLFragments
